module.exports = __webpack_public_path__ + "img/ic_doctor_chat@2x.b73074f7.png";